import { Container } from "postcss";
import React from "react";
import Hero from "./sections/Hero";
import ThemeChanger from "./components/ThemeChanger";
import Navbar from "./components/Navbar";
import TestContainer from "./components/TestContainer";
import AboutMe from "./sections/AboutMe";
import Experience from "./sections/Experience";
import Projects from "./sections/Projects";
import Certificates from "./sections/Certificates";
import ContactMe from "./sections/ContactMe";
import Footer from "./sections/Footer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <div className="font-popins w-full bg-bodyColor dark:bg-darkBodyColor text-titleColor dark:text-darkTitleColor overflow-x-clip">
      <ThemeChanger></ThemeChanger>
      <Navbar></Navbar>
      <Hero></Hero>
      <AboutMe></AboutMe>
      <Experience></Experience>
      <Projects></Projects>
      <Certificates></Certificates>
      <ContactMe></ContactMe>
      <Footer></Footer>
      <ToastContainer></ToastContainer>
    </div>
  );
}

export default App;
